interface CreateStorageParams {
  prefixKey: string
  storage: Storage
  timeout?: Nullable<number>
}

export type Options = Partial<CreateStorageParams>

export const createStorage = ({
  prefixKey = '',
  storage = sessionStorage,
  timeout = null
}: Options = {}) => {
  /**
   * Cache class
   * store data in sessionStorage or localStorage
   * @class Cache
   */
  const WebStorage = class WebStorage {
    private storage: Storage
    private prefixKey?: string

    constructor() {
      this.storage = storage
      this.prefixKey = prefixKey
    }

    private getKey(key: string) {
      return `${this.prefixKey}_${key}`
    }

    /**
     *
     * @param expire Expiration time in seconds
     */
    set(key: string, value: unknown, expire: number | null = timeout) {
      const stringData = JSON.stringify({
        value,
        time: Date.now(),
        expire: expire ? Date.now() + expire * 1000 : null
      })
      this.storage.setItem(this.getKey(key), stringData)
    }

    get(key: string, defaultValue: unknown = null): unknown {
      const val = this.storage.getItem(this.getKey(key))
      if (!val) {
        return defaultValue
      }

      try {
        const data = JSON.parse(val)
        const { value, expire } = data
        if (!expire || expire >= new Date().getTime()) {
          return value
        }
        this.remove(key)
      } catch (e) {
        return defaultValue
      }
    }

    remove(key: string) {
      this.storage.removeItem(this.getKey(key))
    }

    clear() {
      this.storage.clear()
    }
  }

  return new WebStorage()
}
